/**
 * Optimized Leaderboard Management with Pagination and Caching
 */

import LeaderboardManagement from './LeaderboardManagement';
import withOptimization from '../../hoc/withOptimization';

export default withOptimization(LeaderboardManagement, {
  collection: 'leaderboards',
  pageSize: 50,
  orderByField: 'score',
  orderDirection: 'desc',
  cacheTTL: 5 * 60 * 1000
});

/**
 * Performance Improvements:
 * - Before: Loads ALL leaderboard entries (1000+) = 10-15s load time
 * - After: Loads 50 entries at a time = 2-3s load time
 * - Firestore reads: 1000+ → 50-200
 */
